import {makeAutoObservable} from "mobx";
import {ApiComplexesService} from "../../../shared/api";

// "ЖК": one page of complex cards with the search and "what the card lacks" filter (the server searches and counts)
class ComplexesModel {
  complexes = []
  total = 0
  missingCounts = {}
  page = 1
  limit = 50
  search = ''
  missing = undefined
  stock = undefined
  sort = 'onSale'
  isLoading = false
  error = null
  requestId = 0

  constructor() {
    makeAutoObservable(this)
  }

  setList({items, total, page, missingCounts}) {
    this.complexes = items
    this.total = total
    this.page = page
    this.missingCounts = missingCounts || {}
  }

  setLoading(isLoading) {
    this.isLoading = isLoading
  }

  setError(error) {
    this.error = error
  }

  setFilters(filters) {
    Object.assign(this, filters, {page: 1})
    this.fetch()
  }

  setPage(page, limit) {
    this.page = page
    if (limit) this.limit = limit
    this.fetch()
  }

  async fetch() {
    this.requestId += 1
    const requestId = this.requestId
    this.setLoading(true)
    try {
      const {data} = await ApiComplexesService.fetchAdminList({
        search: this.search || undefined,
        missing: this.missing,
        stock: this.stock,
        sort: this.sort,
        page: this.page,
        limit: this.limit,
      })
      if (requestId === this.requestId) {
        this.setList(data)
        this.setError(null)
      }
    } catch (err) {
      if (requestId === this.requestId) this.setError('Не удалось загрузить список ЖК. Обновите страницу.')
    }
    if (requestId === this.requestId) this.setLoading(false)
  }
}

export const complexesModel = new ComplexesModel()
